/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateAddressDto = {
    /**
     * Address ID (required for updating existing address, omit for new address)
     */
    id?: string;
    /**
     * Type of address
     */
    addressType?: UpdateAddressDto.addressType;
    /**
     * Unit number and street address
     */
    unitStreet?: string;
    /**
     * Suburb
     */
    suburb?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Postcode
     */
    postcode?: string;
    /**
     * Country
     */
    country?: string;
    /**
     * Lookup suggestion identifier from address autocomplete. Null clears a previous lookup id for a manual address.
     */
    lookupSuggestionId?: string | null;
};
export namespace UpdateAddressDto {
    /**
     * Type of address
     */
    export enum addressType {
        BILLING_ADDRESS = 'BILLING_ADDRESS',
        BRANCH_ADDRESS = 'BRANCH_ADDRESS',
        BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
        CORRESPONDENCE_ADDRESS = 'CORRESPONDENCE_ADDRESS',
        HOME_ADDRESS = 'HOME_ADDRESS',
        OTHER = 'OTHER',
        REGISTERED_ADDRESS = 'REGISTERED_ADDRESS',
        SITE_ADDRESS = 'SITE_ADDRESS',
    }
}

